import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import SaveIcon from "@mui/icons-material/Save";
import SendIcon from "@mui/icons-material/Send";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CategoryIcon from "@mui/icons-material/Category";
import ItemFieldSearchModal from "./ItemFieldSearchModal";
import { fKeyTabInput } from "../../../Utility/Utilitys";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

export const ItemDetails = ({
  setDetailData,
  aMediaQuery,
  vMediaQuery,
  vRdxTax1,
  detailData,
  handleDetailChange,
  fNew,
  fSave,
  fApprove,
  fDelete,
  detailError,
  headObj,
  fContent_Blur,
  fContent_Focus,
  fExport,
  handleDetailRSPChange,
  handleDetailVATRSPChange,
}) => {
  const [openSearchCatModal, setSearchCatModal] = useState(false);
  const [openSearchBrdModal, setSearchBrdModal] = useState(false);
  const [openSearchVndModal, setSearchVndModal] = useState(false);
  const [searchProps, setSearchProps] = useState({ field: "", value: "" });

  const handleItemCatSearch = (e, fieldName) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setSearchProps({ field: fieldName, value: e.target.value });
      setSearchCatModal(true);

      setTimeout(() => {
        document.getElementById("anyData")?.focus();
      }, 500);
    }
    if (e.key === "Backspace") {
      setDetailData((prev) => ({
        ...prev,
        subCategoryCode: "",
        subCategory: "",
        mainGroupCode: "",
        mainCategory: "",
        categoryCode: "",
        // category:"",
      }));
    }
  };
  const handleItemBrdSearch = (e, fieldName) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setSearchProps({ field: fieldName, value: e.target.value });
      setSearchBrdModal(true);

      setTimeout(() => {
        document.getElementById("anyData")?.focus();
      }, 500);
    }
    if (e.key === "Backspace") {
      setDetailData((prev) => ({
        ...prev,
        brandCode: "",
        // brand: "",
      }));
    }
  };
  const handleItemVndSearch = (e, fieldName) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setSearchProps({ field: fieldName, value: e.target.value });
      setSearchVndModal(true);

      setTimeout(() => {
        document.getElementById("anyData")?.focus();
      }, 500);
    }
    if (e.key === "Backspace") {
      setDetailData((prev) => ({
        ...prev,
        vendorCode: "",
        // vendor: "",
      }));
    }
  };

  return (
    <>
      <Grid
        container
        spacing={{ xs: 1.2, sm: 1.2, md: 1.5, lg: 1.5 }}
        paddingX={vMediaQuery ? 0 : aMediaQuery ? 1 : 2}
        paddingY={vMediaQuery ? 0.5 : aMediaQuery ? 1 : 1.5}
        marginTop={0}
        marginBottom={vMediaQuery ? 1 : 0}
      >
        <Grid item xs={4} sm={2} md={2} lg={2}>
          <TextField
            inputProps={{
              tabIndex: 101,
            }}
            fullWidth
            label="Barcode"
            variant="outlined"
            name="barCode"
            type="number"
            id="barCode"
            autoComplete="off"
            value={detailData?.barCode}
            onChange={handleDetailChange}
            error={!!detailError?.barCode}
            helperText={detailError?.barCode}
            onKeyUp={(e) => {
              fKeyTabInput(e, "itemName");
            }}
          />
        </Grid>
        <Grid item xs={8} sm={5} md={5} lg={5}>
          <TextField
            inputProps={{
              tabIndex: 102,
            }}
            fullWidth
            label="Item Name"
            variant="outlined"
            name="itemName"
            autoComplete="off"
            value={detailData?.itemName}
            onChange={handleDetailChange}
            error={!!detailError?.itemName}
            helperText={detailError?.itemName}
            onKeyUp={(e) => {
              fKeyTabInput(e, "arabicName");
            }}
          />
        </Grid>
        <Grid item xs={12} sm={5} md={5} lg={5}>
          <TextField
            inputProps={{
              tabIndex: 103,
            }}
            fullWidth
            label="Arabic Name"
            variant="outlined"
            name="arabicName"
            autoComplete="off"
            value={detailData?.arabicName}
            onChange={handleDetailChange}
            error={!!detailError?.arabicName}
            helperText={detailError?.arabicName}
            onKeyUp={(e) => {
              fKeyTabInput(e, "category");
            }}
          />
        </Grid>
        <Grid item xs={7} sm={4} md={3} lg={3}>
          <TextField
            inputProps={{
              tabIndex: 104,
            }}
            fullWidth
            label="Category"
            name="category"
            autoComplete="off"
            value={detailData.category}
            onChange={handleDetailChange}
            onKeyDown={(e) => handleItemCatSearch(e, "Category")}
            InputProps={{
              startAdornment: <CategoryIcon />,
              endAdornment: (
                <InputAdornment position="end" sx={{ cursor: "pointer" }}>
                  <SearchIcon
                    onClick={(e) => handleItemCatSearch(e, "Category")}
                  />
                </InputAdornment>
              ),
            }}
            error={!!detailError?.category}
            helperText={detailError?.category}
          />
        </Grid>
        <Grid item xs={5} sm={3} md={2} lg={2.5}>
          <TextField
            fullWidth
            label="Sub Category"
            variant="outlined"
            name="subCategory"
            value={detailData?.subCategory}
            onChange={handleDetailChange}
            error={!!detailError?.subCategory && !detailData?.subCategory}
            helperText={
              !!detailError?.subCategory && !detailData?.subCategory
                ? detailError?.subCategory
                : ""
            }
            disabled={true}
          />
        </Grid>
        <Grid item xs={4} sm={3} md={2.5} lg={2.5}>
          <TextField
            fullWidth
            label="Main Category"
            variant="outlined"
            name="mainCategory"
            value={detailData?.mainCategory}
            onChange={handleDetailChange}
            error={!!detailError?.mainCategory && !detailData?.mainCategory}
            helperText={
              !!detailError?.mainCategory && !detailData?.mainCategory
                ? detailError?.mainCategory
                : ""
            }
            disabled={true}
          />
        </Grid>
        <Grid item xs={3} sm={2} md={1.5} lg={1}>
          <TextField
            inputProps={{
              tabIndex: 106,
            }}
            fullWidth
            label="Packing"
            variant="outlined"
            name="packing"
            autoComplete="off"
            value={detailData?.packing}
            onChange={handleDetailChange}
            error={!!detailError?.packing}
            helperText={detailError?.packing}
            onKeyUp={(e) => {
              fKeyTabInput(e, "brand");
            }}
          />
        </Grid>
        <Grid item xs={5} sm={3.8} md={3} lg={3}>
          <TextField
            inputProps={{
              tabIndex: 107,
            }}
            fullWidth
            label="Brand"
            name="brand"
            autoComplete="off"
            value={detailData?.brand}
            onChange={handleDetailChange}
            error={!!detailError?.brand || !!detailError?.brandCode}
            helperText={detailError?.brand}
            onKeyDown={(e) => handleItemBrdSearch(e, "Brand")}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" sx={{ cursor: "pointer" }}>
                  <SearchIcon
                    onClick={(e) => handleItemBrdSearch(e, "Brand")}
                  />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={4}>
          <TextField
            inputProps={{
              tabIndex: 108,
            }}
            fullWidth
            label="Vendor"
            name="vendor"
            autoComplete="off"
            value={detailData.vendor}
            onChange={handleDetailChange}
            onKeyDown={(e) => handleItemVndSearch(e, "Vendor")}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" sx={{ cursor: "pointer" }}>
                  <SearchIcon
                    onClick={(e) => handleItemVndSearch(e, "Vendor")}
                  />
                </InputAdornment>
              ),
            }}
            error={!!detailError?.vendor}
            helperText={detailError?.vendor}
          />
        </Grid>
        <Grid item xs={6} sm={2.2} md={2} lg={2}>
          <TextField
            inputProps={{
              tabIndex: 109,
            }}
            fullWidth
            select
            label="Tax Dept"
            id="taxDept"
            name="taxDept"
            autoComplete="off"
            value={detailData?.taxDept}
            onChange={handleDetailChange}
            onFocus={fContent_Focus}
            onBlur={fContent_Blur}
            error={!!detailError?.taxDept}
            helperText={detailError?.taxDept}
            onKeyUp={(e) => {
              fKeyTabInput(e, "costPrice");
            }}
          >
            {vRdxTax1?.map((tax) => (
              <MenuItem key={tax.UId} value={tax.UId}>
                {tax.Name1}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={6} sm={3} md={1.5} lg={1.5}>
          <TextField
            inputProps={{
              tabIndex: 109,
            }}
            fullWidth
            type="number"
            label="Tax Perc"
            variant="outlined"
            name="taxPerc"
            autoComplete="off"
            value={detailData?.taxPerc}
            onChange={handleDetailChange}
            onFocus={fContent_Focus}
            onBlur={fContent_Blur}
            error={!!detailError?.taxPerc}
            helperText={detailError?.taxPerc}
            disabled={true}
            onKeyUp={(e) => {
              fKeyTabInput(e, "costPrice");
            }}
          />
        </Grid>
        <Grid item xs={4} sm={3} md={1.5} lg={1.5}>
          <TextField
            inputProps={{
              tabIndex: 109,
            }}
            fullWidth
            type="number"
            label="Cost Price"
            variant="outlined"
            name="costPrice"
            autoComplete="off"
            value={detailData?.costPrice}
            onChange={handleDetailChange}
            onFocus={fContent_Focus}
            onBlur={fContent_Blur}
            error={!!detailError?.costPrice}
            helperText={detailError?.costPrice}
            onKeyUp={(e) => {
              fKeyTabInput(e, "rsp");
            }}
          />
        </Grid>
        <Grid item xs={4} sm={3} md={1.5} lg={1.5}>
          <TextField
            inputProps={{
              tabIndex: 109,
            }}
            fullWidth
            type="number"
            label="RSP"
            variant="outlined"
            name="rsp"
            autoComplete="off"
            value={detailData?.rsp}
            onChange={handleDetailRSPChange}
            onFocus={fContent_Focus}
            onBlur={fContent_Blur}
            error={!!detailError?.rsp}
            helperText={detailError?.rsp}
            onKeyUp={(e) => {
              fKeyTabInput(e, "rspVat");
            }}
          />
        </Grid>
        <Grid item xs={4} sm={3} md={1.5} lg={1.5}>
          <TextField
            inputProps={{
              tabIndex: 109,
            }}
            fullWidth
            type="number"
            label="VAT RSP"
            variant="outlined"
            autoComplete="off"
            name="rspVat"
            value={detailData?.rspVat}
            onChange={handleDetailVATRSPChange}
            onFocus={fContent_Focus}
            onBlur={fContent_Blur}
            error={!!detailError?.rspVat}
            helperText={detailError?.rspVat}
          />
        </Grid>
      </Grid>

      <div
        style={{
          display: "flex",
          justifyContent: vMediaQuery ? "center" : "flex-end",
          alignItems: "center",
        }}
      >
        <Grid
          container
          textAlign={vMediaQuery ? "center" : "right"}
          spacing={{ xs: 0.5, sm: 2, md: 2 }}
          paddingX={vMediaQuery ? 0 : aMediaQuery ? 1 : 2}
          sx={{
            width: "100%",
            justifyContent: vMediaQuery ? "center" : "flex-end",
          }}
        >
          <Grid item xs={4} sm={2} md={1.5} lg={1}>
            <Button
              fullWidth
              variant="contained"
              color="secondary"
              size="small"
              endIcon={<AddIcon />}
              sx={{
                '& .MuiButton-endIcon':{
                  marginLeft:vMediaQuery?'1px': '8px'
                },
                borderRadius: 3,
                boxShadow: 2,
                paddingX: 3,
                color: "#0d73bb",
                textTransform: "capitalize",
              }}
              onClick={fNew}
            >
              New
            </Button>
          </Grid>
          <Grid item xs={4} sm={2} md={1.5} lg={1}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              size="small"
              endIcon={<SaveIcon />}
              sx={{
                '& .MuiButton-endIcon':{
                  marginLeft:vMediaQuery?'1px': '8px'
                },
                borderRadius: 3,
                boxShadow: 2,
                paddingX: 3,
                textTransform: "capitalize",
              }}
              onClick={fSave}
              disabled={
                (headObj?.A_Status == "POST" &&
                  headObj?.A_Confirm_Status !== "REJECT") ||
                headObj?.A_Confirm_Status == "POST" ||
                headObj?.A_Status == "DELETE"
              }
            >
              Save
            </Button>
          </Grid>
          <Grid item xs={4} sm={2} md={1.5} lg={1}>
            <Button
              fullWidth
              variant="contained"
              size="small"
              color="success"
              endIcon={<SendIcon />}
              sx={{
                '& .MuiButton-endIcon':{
                  marginLeft:vMediaQuery?'1px': '8px'
                },
                borderRadius: 3,
                boxShadow: 2,
                paddingX: vMediaQuery ? 1 : 3,
                textTransform: "capitalize",
              }}
              disabled={
                (headObj?.A_Status == "POST" &&
                  headObj?.A_Confirm_Status !== "REJECT") ||
                headObj?.A_Confirm_Status == "POST" ||
                headObj?.A_Status == "DELETE"
              }
              onClick={fApprove}
            >
              Post
            </Button>
          </Grid>
          <Grid item xs={4} sm={2} md={1.5} lg={1}>
            <Button
              fullWidth
              variant="contained"
              color="error"
              size="small"
              endIcon={<DeleteIcon />}
              onClick={fDelete}
              sx={{
                '& .MuiButton-endIcon':{
                  marginLeft:vMediaQuery?'1px': '8px'
                },
                borderRadius: 3,
                boxShadow: 2,
                paddingX: 3,
                textTransform: "capitalize",
                "&:hover": { backgroundColor: "#d32f2f" },
              }}
              disabled={
                (headObj?.A_Status == "POST" &&
                  headObj?.A_Confirm_Status !== "REJECT") ||
                headObj?.A_Confirm_Status == "POST" ||
                headObj?.A_Status == "DELETE" ||
                headObj?.A_Id === 0
              }
            >
              Delete
            </Button>
          </Grid>
          <Grid item xs={4} sm={1.3} md={1} lg={0.5}>
            <Box className="exportBoxv2">
              <IconButton onClick={fExport}>
                <FileDownloadOutlinedIcon />
              </IconButton>
              <Typography variant="caption" sx={{ mt: -1 }}>
                Export
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </div>

      <ItemFieldSearchModal
        xTitle={"Category Modal"}
        open={openSearchCatModal}
        handleClose={() => {
          setSearchCatModal(false);
        }}
        searchProps={searchProps}
        onRowSelect={(selectedRow) => {
          setDetailData((prev) => ({
            ...prev,
            subCategoryCode: selectedRow.SubCategory,
            subCategory: selectedRow.SubCategoryName,
            mainGroupCode: selectedRow.MainGroupCode,
            mainCategory: selectedRow.MainGroupName,
            categoryCode: selectedRow.Code,
            category: selectedRow.Name,
          }));
          setSearchCatModal(false);
          setTimeout(() => {
            document.getElementsByName("packing")[0]?.focus();
          }, 100);
        }}
        anyData={detailData.category}
        vMediaQuery={vMediaQuery}
      />

      <ItemFieldSearchModal
        xTitle={"Brand Modal"}
        open={openSearchBrdModal}
        handleClose={() => {
          setSearchBrdModal(false);
        }}
        searchProps={searchProps}
        onRowSelect={(selectedRow) => {
          setDetailData((prev) => ({
            ...prev,
            brandCode: selectedRow.Code,
            brand: selectedRow.Name,
          }));
          setSearchBrdModal(false);
          setTimeout(() => {
            document.getElementsByName("vendor")[0]?.focus();
          }, 100);
        }}
        anyData={detailData.brand}
        vMediaQuery={vMediaQuery}
      />

      <ItemFieldSearchModal
        xTitle={"Vendor Modal"}
        open={openSearchVndModal}
        handleClose={() => {
          setSearchVndModal(false);
        }}
        searchProps={searchProps}
        onRowSelect={(selectedRow) => {
          setDetailData((prev) => ({
            ...prev,
            vendorCode: selectedRow.Code,
            vendor: selectedRow.Name,
          }));
          setSearchVndModal(false);
          setTimeout(() => {
            document.getElementById("taxDept").focus();
          }, 100);
        }}
        anyData={detailData.vendor}
        vMediaQuery={vMediaQuery}
      />
    </>
  );
};
